import Carousel from './src/carousel';

Carousel.install = function(Vue) {
  Vue.component(Carousel.name, Carousel);
};

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/carousel/index.js